import React from "react";

function SalonGridEmpty(props) {
  const { children } = props;

  return <>{children}</>;
}

export default SalonGridEmpty;
